'use strict';

import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import BoxPay from 'components/signUp/BoxPay';

function mapStateToProps(state) {
  return {
    accessUrl: state.signupReducer.get('accessUrl')
  };
}
function mapDispatchToProps(dispatch) {
  return {
    actions: {
      signUpActions: bindActionCreators(require('actions/signUpActions'), dispatch)
    }
  };
}

export default connect(mapStateToProps, mapDispatchToProps)(BoxPay);



// WEBPACK FOOTER //
// ./src/containers/BoxPayContainer.js